import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import EstimatedValueTeaser from '../EstimatedValueTeaser'
import InterestTeaser from '../InterestTeaser'
import PurchasePowerTeaser from '../PurchasePowerTeaser'
import ExtraPrincipalTeaser from '../ExtraPrincipalTeaser'

import styles from './HomeownerReportTeaser.module.scss'

const propTypes = {
  className: PropTypes.string,
}

const Row = props => <div className={styles.row} {...props} />

const HomeownerReportTeaser = ({ className, ...restProps }) => (
  <div className={classnames(styles.root, className)} {...restProps}>
    <Row>
      <EstimatedValueTeaser.Text className={styles.text} />
      <EstimatedValueTeaser.Screen
        className={classnames(styles.screen, styles.nonOverflow)}
      />
    </Row>

    <Row>
      <InterestTeaser.Text className={styles.text} />
      <InterestTeaser.Screen
        className={classnames(styles.screen, styles.nonOverflow)}
      />
    </Row>

    <Row>
      <PurchasePowerTeaser.Text className={styles.text} />
      <PurchasePowerTeaser.Screen className={styles.screen} />
    </Row>

    <Row>
      <ExtraPrincipalTeaser.Text className={styles.text} />
      <ExtraPrincipalTeaser.Screen
        className={classnames(styles.screen, styles.nonOverflow)}
      />
    </Row>
  </div>
)

HomeownerReportTeaser.propTypes = propTypes

export default HomeownerReportTeaser
